export default function PartnerIndexController(PartnerService) {
  var vm = this;
  var initialize = function initialize() {
    PartnerService.index().then(function(partners) {
      vm.partners = partners;
    });
  };

  initialize();
  return vm;
}

PartnerIndexController.$inject = ['PartnerService'];
